/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_Mch_IdInputs */

const en_admin_settings_fields_wechat_mch_id = /** @type {(inputs: Admin_Settings_Fields_Wechat_Mch_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merchant ID`)
};

/**
* | output |
* | --- |
* | "Merchant ID" |
*
* @param {Admin_Settings_Fields_Wechat_Mch_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_mch_id = /** @type {((inputs?: Admin_Settings_Fields_Wechat_Mch_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_Mch_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_wechat_mch_id(inputs)
});
export { admin_settings_fields_wechat_mch_id as "admin.settings.fields.wechat_mch_id" }